import { Theme } from "@mui/material/styles";
import { DatePickerSlotProps } from "@mui/x-date-pickers/DatePicker";
export const slotProps = (
  theme: Theme,
  variant: "day" | "week" | "month" | "year",
  view: "day" | "month" | "year"
): DatePickerSlotProps<true> => {
  const isCompact = view === "month" || (view === "year" && variant === "year");

  return {
    layout: {
      sx: {
        height: isCompact ? 280 : 360,
      },
    },
    openPickerIcon: {
      sx: {
        fontSize: theme.fontSizes.xl,
      },
    },
    field: {
      openPickerButtonPosition: "start",
      onClick: (e) => {
        e.stopPropagation();
        e.currentTarget.querySelector("button")?.click();
      },
      // @ts-expect-error
      sx: {
        width: 230,
        height: 34,
        
        "& .MuiOutlinedInput-root": {
          backgroundColor: theme.palette.surface.card,
          borderRadius: theme.radius.xss,
        },
        
        "& .MuiInputBase-root": {
          height: 34,
          paddingTop: 1,
          paddingBottom: 1,
          fontSize: theme.fontSizes.md,
        },

        "& .MuiIconButton-root": {
          color: theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.transparent.pure,
          },
        },
      },
    },

    actionBar: {
      actions: [],
    },

    calendarHeader: {
      sx: {
        "& .MuiPickersCalendarHeader-label": {
          paddingX: 1,
          paddingY: 0.5,
          borderRadius: theme.radius.full,
          cursor: "pointer",
          color: theme.palette.text.primary,
          "&:hover": {
            background: theme.palette.action.hover,
          },
        },

        "& .MuiIconButton-root": {
          color: theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },

    day: {
      sx: {
        fontSize: theme.fontSizes.lg,
        color: theme.palette.text.primary,
        "&:hover": {
          backgroundColor: `${theme.palette.action.hover} !important`,
        },

        "&.Mui-selected": {
          backgroundColor: `${theme.palette.primary.main} !important`,
          color: `${theme.palette.primary.contrastText} !important`,
        },

        "&.Mui-selected:hover": {
          backgroundColor: `${theme.palette.primary.dark} !important`,
        },

        "&.Mui-disabled": {
          opacity: 0.38,
          color: theme.palette.text.disabled,
        },
      },
    },

    monthButton: {
      sx: {
        fontSize: theme.fontSizes.lg,
        "&:hover": {
          backgroundColor: `${theme.palette.action.hover} !important`,
        },
        "&.Mui-selected": {
          backgroundColor: `${theme.palette.primary.main} !important`,
          color: theme.palette.primary.contrastText,
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.primary.dark + " !important",
        },
        "&.Mui-disabled": {
          opacity: 0.38,
          color: theme.palette.text.disabled,
        },
      },
    },

    yearButton: {
      sx: {
        fontSize: theme.fontSizes.lg,
        "&:hover": {
          backgroundColor: `${theme.palette.action.hover} !important`,
        },
        "&.Mui-selected": {
          backgroundColor: `${theme.palette.primary.main} !important`,
          color: theme.palette.primary.contrastText,
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.primary.dark + " !important",
        },
        "&.Mui-disabled": {
          opacity: 0.38,
          color: theme.palette.text.disabled,
        },
      },
    },
  };
};
